import { setRoute } from "@/helpers/functions/routeFrom";

export function logRoute(to, from) {
  const listToSave = [
    "bibliotecas_list",
    "bibliotecas_edit",
    "files_list",
    "files_edit",
  ];

  if (listToSave.includes(from.name)) {
    const route = {
      name: from.name,
      params: from.params,
      query: from.query,
    };

    setRoute(route);
    return;
  }
  setRoute({});
}
